export default __webpack_public_path__ + "static/media/Haydn_Creation_Sample.2528dced.mp3";